import Request from '../Request.utils'
export interface ILiveTickerEventsRequestQuery {
  hours?: number;
  limit?: number;
}
export interface IProductCategoriesBreakdownRequestBody {
  categoryType: 'product' | 'contract';
  client?: string;
  filterLocations?: string[];
  postingDateFrom: string;
  postingDateTo: string;
}


class OperationsAPI {
  liveTickerEvents = async (query: ILiveTickerEventsRequestQuery) => {
    const res = await Request.call('/api/operations/live-ticker-events', 'GET', undefined, query, undefined, );
    return res;
  }
  productCategoriesBreakdown = async (body: IProductCategoriesBreakdownRequestBody) => {
    const res = await Request.call('/api/operations/product-categories-breakdown', 'POST', undefined, undefined, body, );
    return res;
  }
}
export default new OperationsAPI()